/* eslint-disable */
import * as React from "react";
import { SlideContext } from "../Context";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useChartHistoricalData } from "../data/useChartHistoricalData";
import { useHighchartHistoricalTransformer } from "../transformers/useHighchartHistoricalTransformer";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart from "../../../../charts/components/HighchartsChart";
import { useExportQuery } from "../export/useExportQuery";
import { useSlideTitle } from "../hooks/useSlideTitle";
import { useSlideSubtitle } from "../hooks/useSlideSubtitle";
import { useSubscriptionSource } from "../../../shared";

export const ComponentChartHistorical: React.FC<{ context: SlideContext }> = (props) => {
  const context = props.context;
  const olapResult = useHookSubscribe(null, context.olapResult$);
  const parameters = useHookSubscribe(null, context.parameters);
  const loading = useHookSubscribe(null, context.loading$);
  const source = useHookSubscribe(null, context.sources$);

  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  useExportQuery(title, subtitle, source, parameters);
  useSubscriptionSource(source);

  const chartData = useChartHistoricalData(olapResult);
  const highchartData = useHighchartHistoricalTransformer(chartData, parameters);

  if (window["exportMode"]) {
    window["exportReady"] = !loading;
  }

  if (loading) {
    return <ComponentPreloader />;
  }
  return (
    <>
      <HighchartsChart data={highchartData} loader={<ComponentPreloader />} />
    </>
  );
};
